import React from 'react';
import {
  compose,
  setDisplayName,
  withProps,
  defaultProps,
} from 'recompose';
import reactCSS from 'reactcss';
import { FormattedMessage } from 'react-intl';
import CascadingFormattedMessage from '@ux/cascading-formatted-message';
import TextButton, { Size, Against } from '@ux/text-button';
import { getStyles } from '@ux/style-utils';
import stylesheet from './Header.stylesheet';
import * as r from 'ramda';
import * as rA from 'ramda-adjunct';

const stylesheetToStyles = r.unary(reactCSS);

export const PureHeader = ({
  theme,
  styles,
  intlNamespace,
  privacyPolicyUrl,
  hasPrivacyPolicy,
  expanded,
}) => (
  <div style={styles.root}>
    <h2 style={styles.title}>
      <FormattedMessage id={`cookie.${intlNamespace}.title`}/>
    </h2>

    <p style={styles.text}>
      <Choose>
        <When condition={expanded}>
          <CascadingFormattedMessage
            cascade={[
              {
                id: `cookie.${intlNamespace}.settings`,
              },
              {
                id: `cookie.${intlNamespace}.description`,
              },
            ]}
          />
        </When>
        <Otherwise>
          <FormattedMessage id={`cookie.${intlNamespace}.description`}/>
        </Otherwise>
      </Choose>
      {' '}
      <If condition={hasPrivacyPolicy}>
        <span style={styles.link}>
          <TextButton
            href={privacyPolicyUrl}
            theme={theme}
            target="_blank"
            against={Against.NEUTRAL}
            size={Size.MD}
          >
            <FormattedMessage id="cookie.privacyPolicy"/>
          </TextButton>
        </span>
      </If>
    </p>
  </div>
);

export const enhance = compose(
  setDisplayName('Header'),
  defaultProps({
    expanded: false,
  }),
  withProps((ownerProps) => ({
    styles: getStyles(stylesheet, stylesheetToStyles, ownerProps),
    hasPrivacyPolicy: r.pipe(
      r.prop('privacyPolicyUrl'),
      rA.isNilOrEmpty,
      r.not,
    )(ownerProps),
  })),
);

export default enhance(PureHeader);
